import { h, Component } from "preact";
import minus from "../../assets/images/seating-map-minus.svg";
import plus from "../../assets/images/seating-map-plus.svg";
export default class Zoom extends Component {
  constructor(props) {
    super(props);
    this.seatingMap = props.seatingMap;
    this.state = {
      zoom: 1
    };
    this.onZoom = this.onZoom.bind(this);
    if (this.seatingMap) {
      this.seatingMap.listenForZoom
        ? this.seatingMap.listenForZoom(this.onZoom)
        : false;
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.seatingMap && nextProps.seatingMap) {
      this.seatingMap = nextProps.seatingMap;
      this.seatingMap.listenForZoom
        ? this.seatingMap.listenForZoom(this.onZoom)
        : false;
    }
  }

  onZoom(zoom) {
    this.setState({ zoom: zoom });
  }

  onZoomClick(perc) {
    const zoom = this.seatingMap.zoom(perc);
    this.setState({ zoom: zoom });
  }

  render() {
    const { zoom } = this.state;
    const { left } = this.props;
    if (this.seatingMap) {
      const zoomStyle = {
        background: "#FFFFFF",
        boxShadow: "0 1px 10px 2px rgba(32, 7, 64, 0.13)",
        borderRadius: 3,
        position: "absolute",
        top: 14
      };
      if (left) {
        zoomStyle.left = 14;
      } else {
        zoomStyle.right = 14;
      }
      return (
        <div style={zoomStyle}>
          <a
            style={{
              float: "left",
              margin: "11px 12px 13px 12px",
              cursor: "pointer",
              width: 14,
              height: 14
            }}
            onClick={() => this.onZoomClick(0.1)}
          >
            <img src={plus} style={{ width: 14, height: 14 }} />
          </a>
          <div
            style={{
              width: 1,
              height: "40px",
              borderLeft: "2px solid #DEDEDE",
              float: "left"
            }}
          />
          <div
            style={{
              fontSize: 16,
              color: "#8E99A8",
              letterSpacing: -0.37,
              float: "left",
              marginTop: 9,
              marginLeft: 12,
              marginRight: 12
            }}
          >{`${(zoom * 100).toFixed(0)}%`}</div>
          <div
            style={{
              width: 1,
              height: "40px",
              borderLeft: "2px solid #DEDEDE",
              float: "left"
            }}
          />
          <a
            style={{
              float: "left",
              margin: "11px 12px 13px 12px",
              cursor: "pointer",
              width: 14,
              height: 14
            }}
            onClick={() => this.onZoomClick(-0.1)}
          >
            <img src={minus} style={{ width: 14, height: 14 }} />
          </a>
        </div>
      );
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./routes/seatingMap/Zoom.js